import { change } from 'redux-form';

import { event } from '@eb/event-create-publish-utils';
import { api as privacyApi } from '@eb/privacy-settings';

const {
    api: { schedulePublishErrorSpec },
} = event;

const {
    getEventScheduleToPublish,
    deleteEventSchedulePrivateToPublish,
} = privacyApi;

import { FORM_NAME, FIELD_NAMES } from './constants';

export const resetCustomMessage = () =>
    change(FORM_NAME, FIELD_NAMES.customMessage, '');

export const deleteSchedulePublishToPublicTimer = async (
    eventId,
    timezone,
    enableEventPrivacyScheduleUI,
) => {
    if (enableEventPrivacyScheduleUI) {
        if (!eventId) {
            return;
        }

        try {
            const schedulePrivacySettings = await getEventScheduleToPublish(
                schedulePublishErrorSpec,
                eventId,
                timezone,
            );
            if (schedulePrivacySettings) {
                deleteEventSchedulePrivateToPublish(
                    schedulePublishErrorSpec,
                    schedulePrivacySettings.id,
                );
            }
        } catch {
            return;
        }
    }
};
